// src/pages/calculators/EOT.jsx
export default function EOTCalculator() {
  return (
    <>
      <h1>End-of-Trip Facilities</h1>
      <p>Showers, lockers, and ancillary allowances.</p>
    </>
  )
}
